function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { Tiles3DModelBuilder } from './Tiles3DModelBuilder';
import { applyCustomMaterialSettings } from '../util/overrideCesiumMaterial'; // for side effects only

var LayerComposingModel = Oskari.clazz.get('Oskari.mapframework.domain.LayerComposingModel');

/**
 * @class Oskari.mapframework.mapmodule.Tiles3DLayerPlugin
 * Provides functionality to draw 3D tiles on the map
 */
Oskari.clazz.define('Oskari.mapframework.mapmodule.Tiles3DLayerPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  this.loc = Oskari.getMsg.bind(null, 'MapModule');
}, {
  __name: 'Tiles3DLayerPlugin',
  _clazz: 'Oskari.mapframework.mapmodule.Tiles3DLayerPlugin',
  layertype: 'tiles3d',
  _layerFilterId: '3d',
  /**
   * Checks if the layer can be handled by this plugin
   * @method  isLayerSupported
   * @param  {Oskari.mapframework.domain.AbstractLayer}  layer
   * @return {Boolean} true if this plugin handles the type of layers
   */
  isLayerSupported: function isLayerSupported(layer) {
    if (!layer) {
      return false;
    }
    return layer.isLayerOfType(this.layertype);
  },
  /**
   * Applies currently selected Oskari style to tileset.
   *
   * @method  _applyOskariStyle
   * @param  {Cesium.Cesium3DTileset}  tileset
   */
  _applyOskariStyle: function _applyOskariStyle(tileset, layer) {
    if (!tileset || !layer) {
      return;
    }
    tileset.style = this.getMapModule().get3DStyle(layer.getCurrentStyle(), layer.getOpacity());
  },
  /**
   * @private @method _initImpl
   * Interface method for the module protocol.
   */
  _initImpl: function _initImpl() {
    var _this = this;
    // register domain builder
    var mapLayerService = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
    if (mapLayerService) {
      var registerType = this.layertype + 'layer';
      var clazz = 'Oskari.mapframework.mapmodule.Tiles3DLayer';
      var composingModel = new LayerComposingModel([LayerComposingModel.CESIUM_ION, LayerComposingModel.SRS, LayerComposingModel.VECTOR_STYLES, LayerComposingModel.EXTERNAL_VECTOR_STYLES, LayerComposingModel.URL]);
      mapLayerService.registerLayerModel(registerType, clazz, composingModel);
      mapLayerService.registerLayerModelBuilder(registerType, new Tiles3DModelBuilder());
      // register layerlist filter for 3D layers
      mapLayerService.registerLayerFilter(this._layerFilterId, function (layer) {
        return layer.isLayerOfType(_this.layertype);
      });
    }
    this._registerForLayerFiltering();
    if (!this.getMapModule().getSupports3D()) {
      return;
    }
    this._initTilesetClickHandler();
    applyCustomMaterialSettings();
  },
  _registerForLayerFiltering: function _registerForLayerFiltering() {
    var _this2 = this;
    // Add layerlist filter button for 3D layers after app is started
    Oskari.on('app.start', function () {
      var layerlistService = Oskari.getSandbox().getService('Oskari.mapframework.service.LayerlistService');
      if (layerlistService) {
        var id = _this2._layerFilterId;
        layerlistService.registerLayerlistFilterButton(Oskari.getMsg('MapModule', 'plugin.Tiles3DLayerPlugin.layerFilter.text'), Oskari.getMsg('MapModule', 'plugin.Tiles3DLayerPlugin.layerFilter.tooltip'), {
          active: 'layer-' + id,
          deactive: 'layer-' + id + '-disabled'
        }, id);
      }
    });
  },
  /**
   * @method _afterChangeMapLayerOpacityEvent
   * Handle AfterChangeMapLayerOpacityEvent
   * @private
   * @param {Oskari.mapframework.event.common.AfterChangeMapLayerOpacityEvent}
   *            event
   */
  _afterChangeMapLayerOpacityEvent: function _afterChangeMapLayerOpacityEvent(event) {
    var _this3 = this;
    var layer = event.getMapLayer();
    var tilesets = this.getOLMapLayers(layer);
    if (!tilesets || tilesets.length === 0) {
      return;
    }
    tilesets.forEach(function (tileset) {
      return _this3._applyOskariStyle(tileset, layer);
    });
  },
  /**
   * Handle AfterChangeMapLayerStyleEvent
   * @private
   * @param {Oskari.mapframework.event.common.AfterChangeMapLayerStyleEvent} event
   */
  _afterChangeMapLayerStyleEvent: function _afterChangeMapLayerStyleEvent(event) {
    var _this4 = this;
    var layer = event.getMapLayer();
    var tilesets = this.getOLMapLayers(layer);
    if (!tilesets || tilesets.length === 0) {
      return;
    }
    tilesets.forEach(function (tileset) {
      return _this4._applyOskariStyle(tileset, layer);
    });
  },
  /**
   * Handle 3D tile feature clicks
   * @private
   */
  _initTilesetClickHandler: function _initTilesetClickHandler() {
    var _this5 = this;
    var me = this;
    var scene = me.getMapModule().getCesiumScene();
    var handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
    handler.setInputAction(function (movement) {
      var feature = scene.pick(movement.position);
      if (!(feature instanceof Cesium.Cesium3DTileFeature)) {
        return;
      }
      var tableContent = '';
      feature.getPropertyNames().forEach(function (name) {
        tableContent += "<tr><td>".concat(name, "</td><td>").concat(feature.getProperty(name), "</td></tr>");
      });
      if (tableContent.length === 0) {
        return;
      }
      var content = [{
        html: "<table>".concat(tableContent, "</table>")
      }];
      var location = me.getMapModule().getMouseLocation(movement.position);
      // Request info box
      var infoRequestBuilder = Oskari.requestBuilder('InfoBox.ShowInfoBoxRequest');
      var title = me.loc('plugin.GetInfoPlugin.title');
      _this5._sandbox.request(me, infoRequestBuilder('tilesetFeatureAttributes', title, content, location));
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  },
  /**
   * Disable shadows for tilesets containing point cloud tiles.
   * Improves rendering performance.
   * @private
   *
   * @method disablePointCloudShadows
   * @param {Cesium.Cesium3DTileset} tileset
   */
  _disablePointCloudShadows: function _disablePointCloudShadows(tileset) {
    var _tileTypeCheck = function tileTypeCheck(tile) {
      if (tile.content.pointsLength > 0) {
        tileset.shadows = Cesium.ShadowMode.DISABLED;
        tileset.tileLoad.removeEventListener(_tileTypeCheck);
      }
    };
    tileset.tileLoad.addEventListener(_tileTypeCheck);
  },
  /**
   * Adds a single 3d tileset to this map
   *
   * @method addMapLayerToMap
   * @param {Oskari.map3dtiles.bundle.tiles3d.domain.Tiles3DLayer} layer
   */
  addMapLayerToMap: function addMapLayerToMap(layer) {
    if (!this.getMapModule().getSupports3D()) {
      return;
    }
    // moved to own func because of async/await requirement
    this.__addTileset(layer);
  },
  __addTileset: function () {
    var _addTileset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(layer) {
      var options, url, tileset;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            options = layer.getOptions() || {};
            _context.next = 3;
            return this.__getURL(layer, options);
          case 3:
            url = _context.sent;
            _context.next = 6;
            return Cesium.Cesium3DTileset.fromUrl(url, _objectSpread({
              dynamicScreenSpaceError: true,
              dynamicScreenSpaceErrorDensity: 0.00278,
              dynamicScreenSpaceErrorFactor: 4.0,
              dynamicScreenSpaceErrorHeightFalloff: 0.25
            }, options));
          case 6:
            tileset = _context.sent;
            this._disablePointCloudShadows(tileset);
            this._applyOskariStyle(tileset, layer);
            this.getMapModule().addLayer(tileset);

            // store reference to layers
            this.setOLMapLayers(layer.getId(), tileset);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function __addTileset(_x) {
      return _addTileset.apply(this, arguments);
    }
    return __addTileset;
  }(),
  __getURL: function () {
    var _getURL = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(layer, options) {
      var ionAssetId, ionAssetServer, ionAccessToken, ionResourceOpts;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            ionAssetId = options.ionAssetId, ionAssetServer = options.ionAssetServer, ionAccessToken = options.ionAccessToken;
            if (ionAssetId) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", layer.getLayerUrl());
          case 3:
            ionResourceOpts = {};
            if (ionAssetServer) {
              // check truthy, we might have empty string defined and Cesium only checks for null/undefined for defaulting.
              ionResourceOpts.server = ionAssetServer;
            }
            if (ionAccessToken) {
              ionResourceOpts.accessToken = ionAccessToken;
            }
            return _context2.abrupt("return", Cesium.IonResource.fromAssetId(ionAssetId, ionResourceOpts));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function __getURL(_x2, _x3) {
      return _getURL.apply(this, arguments);
    }
    return __getURL;
  }(),
  /**
   * Called when layer details are updated (for example by the admin functionality)
   * @param {Oskari.mapframework.domain.AbstractLayer} layer new layer details
   */
  _updateLayer: function _updateLayer(layer) {
    // no-op - 3DTiles scale limits or runtime changes to config not supported at this time
  }
}, {
  extend: ['Oskari.mapping.mapmodule.AbstractMapLayerPlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});